<div class="modal-header">
  <h2 class="modal-title" i18n="@@info">Info</h2>
  <button
    type="button"
    class="light-icon-button close"
    aria-label="Close"
    (click)="activeModal.close(false)"
    ngbAutoFocus
  >
    <i class="ico-cancel AA-standard-grey" aria-hidden="true"></i>
  </button>
</div>
<div class="modal-body">
  @if (hotelDetail) {
    <div>
      <div class="hotel-header">
        <img
          [src]="thumbUrl"
          class="hotel-header-image"
          alt="image of {{ hotelDetail.name ? hotelDetail.name : 'hotel' }}"
        />
        <div class="hotel-header-details">
          <h3 [innerHTML]="hotelDetail.name"></h3>
          @if (address) {
            <div class="address">{{ address }}</div>
          }
          @if (hotelDetail?.address?.telephone || hotelDetail?.address?.facsimile) {
            <dl>
              @if (hotelDetail?.address?.telephone) {
                <div class="inline-dl">
                  <dt>
                    <i class="ico-call-phone" aria-hidden="true"></i>
                    <span class="visuallyhidden" i18n="@@phoneNumberTitleCaps">Phone Number</span>
                  </dt>
                  <dd>
                    {{ hotelDetail?.address?.telephone }}
                  </dd>
                </div>
              }
              @if (hotelDetail?.address?.facsimile) {
                <div class="inline-dl">
                  <dt>
                    <i class="ico-icon-print" aria-hidden="true"></i>
                    <span class="visuallyhidden" i18n="@@hotelInfoFax">Fax</span>
                  </dt>
                  <dd>
                    {{ hotelDetail?.address?.facsimile }}
                  </dd>
                </div>
              }
            </dl>
          }
        </div>
      </div>
      <!-- LOCATION -->
      @if (hotelDetail.transports) {
        <div>
          <div class="hotel-location">
            <b i18n="@@itemHotelsLocation">Location</b>:
            @for (transport of hotelDetail.transports; track transport) {
              <span>
                @if (transport.type === hotelDetailTypes.METRO) {
                  <span class="location-distance">
                    <i class="ico-metro" aria-hidden="true"></i>
                    <span class="visuallyhidden">Closest Underground Station</span>
                    {{ transport | switchDistanceFormat: userDistanceUnit | number: '1.1-1' }}
                    <span i18n="@@itemHotelsDistanceTypes">{{ userDistanceUnit | lowercase }}</span>
                  </span>
                }
                @if (transport.type === hotelDetailTypes.TRAIN) {
                  <span class="location-distance">
                    <i class="ico-rail" aria-hidden="true"></i>
                    <span class="visuallyhidden">Closest Train Station</span>
                    {{ transport | switchDistanceFormat: userDistanceUnit | number: '1.1-1' }}
                    <span i18n="@@itemHotelsDistanceTypes">{{ userDistanceUnit | lowercase }}</span>
                  </span>
                }
                @if (transport.type === hotelDetailTypes.AIRPORT) {
                  <span class="location-distance">
                    <i class="ico-flight" aria-hidden="true"></i>
                    <span class="visuallyhidden">Closest Airport</span>
                    {{ transport | switchDistanceFormat: userDistanceUnit | number: '1.1-1' }}
                    <span i18n="@@itemHotelsDistanceTypes">{{ userDistanceUnit | lowercase }}</span>
                  </span>
                  @if (
                    hotelDetail?.Details?.airport_details &&
                    hotelDetail?.Details?.airport_details?.name
                  ) {
                    <span class="location-distance">
                      <i class="ico-flight" aria-hidden="true"></i>{{ transport.name }}
                    </span>
                  }
                }
              </span>
            }
          </div>
        </div>
      }
      <!-- END LOCATION -->
      <!-- FACILITIES -->
      <div class="facilities">
        @if (hotelFacilities.length) {
          <div class="hotel-facilities">
            <h4 i18n="@@hotelFacilities">Hotel Facilities</h4>
            @for (facility of hotelFacilities; track facility) {
              <div class="facility-wrapper">
                <img class="facility-img" [src]="facility.icon" alt="{{ facility.name }}" />{{
                  facility.name | translate
                }}
              </div>
            }
          </div>
        }
        @if (roomFacilities.length) {
          <div class="room-facilities">
            <h4 i18n="@@roomFacilities">Room Facilities</h4>
            @for (facility of roomFacilities; track facility) {
              <div class="facility-wrapper">
                <img class="facility-img" [src]="facility.icon" alt="{{ facility.name }}" />{{
                  facility.name | translate
                }}
              </div>
            }
          </div>
        }
      </div>
      <!-- END FACILITIES -->
      @if (hotelDetail?.source === 'Conferma') {
        <div>
          <p class="infoDisclaimer" i18n="@@infoDisclaimer">
            * This information was collected from third party systems. Conferma Ltd accepts no
            responsibility for the accuracy of the data provided.
          </p>
          <img
            src="https://images.sabscorp.com/images/logo/conferma.gif"
            alt="Powered by conferma"
          />
        </div>
      }
    </div>
  }

  @if (!hotelDetail) {
    <div i18n="@@noData">No data...</div>
  }
</div>
